module.exports = __webpack_public_path__ + "img/Signatureold.349318d8.svg";